"use client";
import { RefObject, useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { AlertProps, LayoutProps, TransitionType } from "@/components/layout/layoutType";
import { AlertContext } from "@/components/context/alertContext";

import Icon from "@/components/common/icon/sicon";
import Link from "next/link";
import { Button, Flex, Input, InputRef } from "antd";
import { Debug } from "@/util/debug";
import { alertClose, setTimeoutDelay } from "../layout/list/defaultType";
import { appRouterPush, getPrefetch, useLinkRouter } from "@/util/apputil";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { checkEmpty } from "@/util/stringutil";
const clickLink = (t: TransitionType, router: AppRouterInstance, linkRef: RefObject<InputRef | null>, alertContext: AlertProps) => {
  const inputValue = linkRef.current?.input?.value;
  const link_href =
    inputValue !== undefined && inputValue.indexOf(window.location.origin.toString()) === 0
      ? inputValue.substring(window.location.origin.toString().length).trim()
      : (inputValue ?? "").trim();
  const linkRegex =
    /^(\/)?(info\/)?(bean\/(rd|rt|cd|ct)|beannote\/(beaninfo|beandetail|coffeebean|coffeebeandetail)|brewing\/(note|user|cafe|roaster))/g;
  if (linkRegex.test(link_href)) {
    const link_href_check_1 = link_href.substring(0, 1) !== "/" ? "/" + link_href : link_href;
    const link_href_check_2 = link_href_check_1.startsWith("/info") ? link_href_check_1 : "/info" + link_href_check_1;
    appRouterPush(router, link_href_check_2);
  } else {
    const alert_p = alertContext.setProp;
    if (alert_p) {
      alert_p({
        open: true,
        title: t("validation_error"),
        description: t("link_validation_error_detail"),
        useCancel: false,
        useOk: true,
        okFunction: () => {
          setTimeout(() => {
            alert_p(alertClose);
          }, setTimeoutDelay);
        },
      });
    }
  }
  Debug(inputValue, link_href, linkRegex.test(link_href));
};
export default function IntroLink({ params, intro_text, sample_link }: { params?: LayoutProps; intro_text: string; sample_link: string }) {
  const t = useTranslations("alert");
  const [loading, setLoading] = useState<boolean>(true);
  const linkRef = useRef<InputRef>(null);
  const alertContext = useContext(AlertContext);
  const router = useRouter();
  const prefetch = getPrefetch();
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Skeleton loading={loading}>
      <Text as="div" size="4" weight="bold" className="min-w-12 whitespace-pre-wrap text-center mt-8 line leading-[2rem]">
        {t.rich(intro_text, {
          link: (link_text) => (
            <Link
              href={sample_link}
              className="ml-2 link-font-accent"
              prefetch={prefetch}
              onClick={(e) => {
                e.preventDefault();
                const inputValue = linkRef.current?.input?.value;
                if (checkEmpty(inputValue)) {
                  if (linkRef.current?.input) {
                    linkRef.current.input.value = sample_link;
                  }
                }
                clickLink(t, router, linkRef, alertContext);
              }}
            >
              {link_text}
            </Link>
          ),
        })}
      </Text>
      <Flex className="mt-4">
        <Input ref={linkRef} placeholder={t("link_info_placeolder")} defaultValue={sample_link} allowClear={true}></Input>
        <Button
          className="ml-2"
          icon={<Icon iconName="Link" iconType=""></Icon>}
          onClick={(e) => {
            clickLink(t, router, linkRef, alertContext);
          }}
        ></Button>
      </Flex>
    </Skeleton>
  );
}
